'use client'

import { useEffect, useState } from 'react'
import { Loader2 } from 'lucide-react'

interface ThinkingIndicatorProps {
  content?: string
  toolCallCount?: number
  currentToolCalls?: string[]
}

/**
 * Animated thinking / tool-execution indicator shown while the
 * assistant is processing. Uses a spinner + contextual label.
 */
export function ThinkingIndicator({
  content,
  toolCallCount,
  currentToolCalls,
}: ThinkingIndicatorProps) {
  const [dotCount, setDotCount] = useState(1)

  useEffect(() => {
    const interval = setInterval(() => setDotCount(d => (d % 3) + 1), 500)
    return () => clearInterval(interval)
  }, [])

  let displayText = content?.trim() || 'Thinking'

  if (toolCallCount && toolCallCount > 0) {
    const latestTool = currentToolCalls?.[currentToolCalls.length - 1]
    displayText = `Running ${latestTool || 'tool'} (${toolCallCount} tool${toolCallCount > 1 ? 's' : ''} called)`
  }

  return (
    <div className="flex items-center gap-2 py-1 text-muted-foreground">
      <Loader2 className="size-4 animate-spin" />
      <span className="text-sm italic">
        {displayText}{'.'.repeat(dotCount)}
      </span>
    </div>
  )
}
